const countryCodesAndFlags = [
  {
    key: 'United States',
    text: '+1',
    flag: 'us',
    value: '+1',
  },
  {
    key: 'Afghanistan',
    text: '+93',
    flag: 'af',
    value: '+93',
  },
  {
    key: 'Åland Islands',
    text: '+358',
    flag: 'ax',
    value: '+358',
  },
  {
    key: 'Albania',
    text: '+355',
    flag: 'al',
    value: '+355',
  },
  {
    key: 'Algeria',
    text: '+213',
    flag: 'dz',
    value: '+213',
  },
  {
    key: 'American Samoa',
    text: '+1684',
    flag: 'as',
    value: '+1684',
  },
  {
    key: 'Andorra',
    text: '+376',
    flag: 'ad',
    value: '+376',
  },
  {
    key: 'Angola',
    text: '+244',
    flag: 'ao',
    value: '+244',
  },
  {
    key: 'Anguilla',
    text: '+1264',
    flag: 'ai',
    value: '+1264',
  },
  /* {
    key: 'Antarctica',
    text: '+672',
    flag: 'aq',
    value: '+672',
  }, */
  {
    key: 'Antigua and Barbuda',
    text: '+1268',
    flag: 'ag',
    value: '+1268',
  },
  {
    key: 'Argentina',
    text: '+54',
    flag: 'ar',
    value: '+54',
  },
  {
    key: 'Armenia',
    text: '+374',
    flag: 'am',
    value: '+374',
  },
  {
    key: 'Aruba',
    text: '+297',
    flag: 'aw',
    value: '+297',
  },
  {
    key: 'Australia',
    text: '+61',
    flag: 'au',
    value: '+61',
  },
  {
    key: 'Austria',
    text: '+43',
    flag: 'at',
    value: '+43',
  },
  {
    key: 'Azerbaijan',
    text: '+994',
    flag: 'az',
    value: '+994',
  },
  {
    key: 'Bahamas',
    text: '+1242',
    flag: 'bs',
    value: '+1242',
  },
  {
    key: 'Bahrain',
    text: '+973',
    flag: 'bh',
    value: '+973',
  },
  {
    key: 'Bangladesh',
    text: '+880',
    flag: 'bd',
    value: '+880',
  },
  {
    key: 'Barbados',
    text: '+1246',
    flag: 'bb',
    value: '+1246',
  },
  {
    key: 'Belarus',
    text: '+375',
    flag: 'by',
    value: '+375',
  },
  {
    key: 'Belgium',
    text: '+32',
    flag: 'be',
    value: '+32',
  },
  {
    key: 'Belize',
    text: '+501',
    flag: 'bz',
    value: '+501',
  },
  {
    key: 'Benin',
    text: '+229',
    flag: 'bj',
    value: '+229',
  },
  {
    key: 'Bermuda',
    text: '+1441',
    flag: 'bm',
    value: '+1441',
  },
  {
    key: 'Bhutan',
    text: '+975',
    flag: 'bt',
    value: '+975',
  },
  {
    key: 'Bolivia, Plurinational State of bolivia',
    text: '+591',
    flag: 'bo',
    value: '+591',
  },
  {
    key: 'Bosnia and Herzegovina',
    text: '+387',
    flag: 'ba',
    value: '+387',
  },
  {
    key: 'Botswana',
    text: '+267',
    flag: 'bw',
    value: '+267',
  },
  {
    key: 'Bouvet Island',
    text: '+47',
    flag: 'bv',
    value: '+47',
  },
  {
    key: 'Brazil',
    text: '+55',
    flag: 'br',
    value: '+55',
  },
  {
    key: 'British Indian Ocean Territory',
    text: '+246',
    flag: 'io',
    value: '+246',
  },
  {
    key: 'Brunei Darussalam',
    text: '+673',
    flag: 'bn',
    value: '+673',
  },
  {
    key: 'Bulgaria',
    text: '+359',
    flag: 'bg',
    value: '+359',
  },
  {
    key: 'Burkina Faso',
    text: '+226',
    flag: 'bf',
    value: '+226',
  },
  {
    key: 'Burundi',
    text: '+257',
    flag: 'bi',
    value: '+257',
  },
  {
    key: 'Cambodia',
    text: '+855',
    flag: 'kh',
    value: '+855',
  },
  {
    key: 'Cameroon',
    text: '+237',
    flag: 'cm',
    value: '+237',
  },
  {
    key: 'Canada',
    text: '+1',
    flag: 'ca',
    value: '+1',
  },
  {
    key: 'Cape Verde',
    text: '+238',
    flag: 'cv',
    value: '+238',
  },
  {
    key: 'Cayman Islands',
    text: '+345',
    flag: 'ky',
    value: '+345',
  },
  {
    key: 'Central African Republic',
    text: '+236',
    flag: 'cf',
    value: '+236',
  },
  {
    key: 'Chad',
    text: '+235',
    flag: 'td',
    value: '+235',
  },
  {
    key: 'Chile',
    text: '+56',
    flag: 'cl',
    value: '+56',
  },
  {
    key: 'China',
    text: '+86',
    flag: 'cn',
    value: '+86',
  },
  {
    key: 'Christmas Island',
    text: '+61',
    flag: 'cx',
    value: '+61',
  },
  {
    key: 'Cocos (Keeling) Islands',
    text: '+61',
    flag: 'cc',
    value: '+61',
  },
  {
    key: 'Colombia',
    text: '+57',
    flag: 'cd',
    value: '+57',
  },
  {
    key: 'Comoros',
    text: '+269',
    flag: 'km',
    value: '+269',
  },
  {
    key: 'Congo',
    text: '+242',
    flag: 'cg',
    value: '+242',
  },
  {
    key: 'Congo, The Democratic Republic of the Congo',
    text: '+243',
    flag: 'cd',
    value: '+243',
  },
  {
    key: 'Cook Islands',
    text: '+682',
    flag: 'ck',
    value: '+682',
  },
  {
    key: 'Costa Rica',
    text: '+506',
    flag: 'cr',
    value: '+506',
  },
  {
    key: 'Cote d`Ivoire',
    text: '+225',
    flag: 'ci',
    value: '+225',
  },
  {
    key: 'Croatia',
    text: '+385',
    flag: 'hr',
    value: '+385',
  },
  {
    key: 'Cuba',
    text: '+53',
    flag: 'cu',
    value: '+53',
  },
  {
    key: 'Cyprus',
    text: '+357',
    flag: 'cy',
    value: '+357',
  },
  {
    key: 'Czech Republic',
    text: '+420',
    flag: 'cz',
    value: '+420',
  },
  {
    key: 'Denmark',
    text: '+45',
    flag: 'dk',
    value: '+45',
  },
  {
    key: 'Djibouti',
    text: '+253',
    flag: 'dj',
    value: '+253',
  },
  {
    key: 'Dominica',
    text: '+1767',
    flag: 'dm',
    value: '+1767',
  },
  {
    key: 'Dominican Republic',
    text: '+1849',
    flag: 'do',
    value: '+1849',
  },
  {
    key: 'Ecuador',
    text: '+593',
    flag: 'ec',
    value: '+593',
  },
  {
    key: 'Egypt',
    text: '+20',
    flag: 'eg',
    value: '+20',
  },
  {
    key: 'El Salvador',
    text: '+503',
    flag: 'sv',
    value: '+503',
  },
  {
    key: 'Equatorial Guinea',
    text: '+240',
    flag: 'gq',
    value: '+240',
  },
  {
    key: 'Eritrea',
    text: '+291',
    flag: 'er',
    value: '+291',
  },
  {
    key: 'Estonia',
    text: '+372',
    flag: 'ee',
    value: '+372',
  },
  {
    key: 'Ethiopia',
    text: '+251',
    flag: 'et',
    value: '+251',
  },
  {
    key: 'Falkland Islands (Malvinas)',
    text: '+500',
    flag: 'fk',
    value: '+500',
  },
  {
    key: 'Faroe Islands',
    text: '+298',
    flag: 'fo',
    value: '+298',
  },
  {
    key: 'Fiji',
    text: '+679',
    flag: 'fj',
    value: '+679',
  },
  {
    key: 'Finland',
    text: '+358',
    flag: 'fi',
    value: '+358',
  },
  {
    key: 'France',
    text: '+33',
    flag: 'fr',
    value: '+33',
  },
  {
    key: 'French Guiana',
    text: '+594',
    flag: 'gf',
    value: '+594',
  },
  {
    key: 'French Polynesia',
    text: '+689',
    flag: 'pf',
    value: '+689',
  },
  {
    key: 'French Southern Territories',
    text: '+262',
    flag: 'tf',
    value: '+262',
  },
  {
    key: 'Gabon',
    text: '+241',
    flag: 'ga',
    value: '+241',
  },
  {
    key: 'Gambia',
    text: '+220',
    flag: 'gm',
    value: '+220',
  },
  {
    key: 'Georgia',
    text: '+995',
    flag: 'ge',
    value: '+995',
  },
  {
    key: 'Germany',
    text: '+49',
    flag: 'de',
    value: '+49',
  },
  {
    key: 'Ghana',
    text: '+233',
    flag: 'gh',
    value: '+233',
  },
  {
    key: 'Gibraltar',
    text: '+350',
    flag: 'gi',
    value: '+350',
  },
  {
    key: 'Greece',
    text: '+30',
    flag: 'gr',
    value: '+30',
  },
  {
    key: 'Greenland',
    text: '+299',
    flag: 'gl',
    value: '+299',
  },
  {
    key: 'Grenada',
    text: '+1473',
    flag: 'gd',
    value: '+1473',
  },
  {
    key: 'Guadeloupe',
    text: '+590',
    flag: 'gp',
    value: '+590',
  },
  {
    key: 'Guam',
    text: '+1671',
    flag: 'gu',
    value: '+1671',
  },
  {
    key: 'Guatemala',
    text: '+502',
    flag: 'gt',
    value: '+502',
  },
  /*  {
    key: 'Guernsey',
    text: '+44',
    flag: 'gg',
    value: '+44',
  }, */
  {
    key: 'Guinea',
    text: '+224',
    flag: 'gn',
    value: '+224',
  },
  {
    key: 'Guinea-Bissau',
    text: '+245',
    flag: 'gw',
    value: '+245',
  },
  {
    key: 'Guyana',
    text: '+592',
    flag: 'gy',
    value: '+592',
  },
  {
    key: 'Haiti',
    text: '+509',
    flag: 'ht',
    value: '+509',
  },
  {
    key: 'Heard Island and Mcdonald Islands',
    text: '+0',
    flag: 'hm',
    value: '+0',
  },
  {
    key: 'Holy See (Vatican City State)',
    text: '+379',
    flag: 'va',
    value: '+379',
  },
  {
    key: 'Honduras',
    text: '+504',
    flag: 'hn',
    value: '+504',
  },
  {
    key: 'Hong Kong',
    text: '+852',
    flag: 'hk',
    value: '+852',
  },
  {
    key: 'Hungary',
    text: '+36',
    flag: 'hu',
    value: '+36',
  },
  {
    key: 'Iceland',
    text: '+354',
    flag: 'is',
    value: '+354',
  },
  {
    key: 'India',
    text: '+91',
    flag: 'in',
    value: '+91',
  },
  {
    key: 'Indonesia',
    text: '+62',
    flag: 'id',
    value: '+62',
  },
  {
    key: 'Iran, Islamic Republic of Persian Gulf',
    text: '+98',
    flag: 'ir',
    value: '+98',
  },
  {
    key: 'Iraq',
    text: '+964',
    flag: 'iq',
    value: '+964',
  },
  {
    key: 'Ireland',
    text: '+353',
    flag: 'ie',
    value: '+353',
  },
  /*  {
    key: 'Isle of Man',
    text: '+44',
    flag: 'im',
    value: '+44',
  }, */
  {
    key: 'Israel',
    text: '+972',
    flag: 'il',
    value: '+972',
  },
  {
    key: 'Italy',
    text: '+39',
    flag: 'it',
    value: '+39',
  },
  {
    key: 'Jamaica',
    text: '+1876',
    flag: 'jm',
    value: '+1876',
  },
  {
    key: 'Japan',
    text: '+81',
    flag: 'jp',
    value: '+81',
  },
  {
    key: 'Jordan',
    text: '+962',
    flag: 'jo',
    value: '+962',
  },
  {
    key: 'Kazakhstan',
    text: '+7',
    flag: 'kz',
    value: '+7',
  },
  {
    key: 'Kenya',
    text: '+254',
    flag: 'ke',
    value: '+254',
  },
  {
    key: 'Kiribati',
    text: '+686',
    flag: 'ki',
    value: '+686',
  },
  {
    key: 'Korea, Democratic People`s Republic of Korea',
    text: '+850',
    flag: 'kp',
    value: '+850',
  },
  {
    key: 'Korea, Republic of South Korea',
    text: '+82',
    flag: 'kr',
    value: '+82',
  },
  {
    key: 'Kuwait',
    text: '+965',
    flag: 'kw',
    value: '+965',
  },
  {
    key: 'Kyrgyzstan',
    text: '+996',
    flag: 'kg',
    value: '+996',
  },
  {
    key: 'Laos',
    text: '+856',
    flag: 'la',
    value: '+856',
  },
  {
    key: 'Latvia',
    text: '+371',
    flag: 'lv',
    value: '+371',
  },
  {
    key: 'Lebanon',
    text: '+961',
    flag: 'lb',
    value: '+961',
  },
  {
    key: 'Lesotho',
    text: '+266',
    flag: 'ls',
    value: '+266',
  },
  {
    key: 'Liberia',
    text: '+231',
    flag: 'lr',
    value: '+231',
  },
  {
    key: 'Libyan Arab Jamahiriya',
    text: '+218',
    flag: 'ly',
    value: '+218',
  },
  {
    key: 'Liechtenstein',
    text: '+423',
    flag: 'li',
    value: '+423',
  },
  {
    key: 'Lithuania',
    text: '+370',
    flag: 'lt',
    value: '+370',
  },
  {
    key: 'Luxembourg',
    text: '+352',
    flag: 'lu',
    value: '+352',
  },
  {
    key: 'Macao',
    text: '+853',
    flag: 'mo',
    value: '+853',
  },
  {
    key: 'Macedonia',
    text: '+389',
    flag: 'mk',
    value: '+389',
  },
  {
    key: 'Madagascar',
    text: '+261',
    flag: 'mg',
    value: '+261',
  },
  {
    key: 'Malawi',
    text: '+265',
    flag: 'mw',
    value: '+265',
  },
  {
    key: 'Malaysia',
    text: '+60',
    flag: 'my',
    value: '+60',
  },
  {
    key: 'Maldives',
    text: '+960',
    flag: 'mv',
    value: '+960',
  },
  {
    key: 'Mali',
    text: '+223',
    flag: 'ml',
    value: '+223',
  },
  {
    key: 'Malta',
    text: '+356',
    flag: 'mt',
    value: '+356',
  },
  {
    key: 'Marshall Islands',
    text: '+692',
    flag: 'mh',
    value: '+692',
  },
  {
    key: 'Martinique',
    text: '+596',
    flag: 'mq',
    value: '+596',
  },
  {
    key: 'Mauritania',
    text: '+222',
    flag: 'mr',
    value: '+222',
  },
  {
    key: 'Mauritius',
    text: '+230',
    flag: 'mu',
    value: '+230',
  },
  {
    key: 'Mayotte',
    text: '+262',
    flag: 'yt',
    value: '+262',
  },
  {
    key: 'Mexico',
    text: '+52',
    flag: 'mx',
    value: '+52',
  },
  {
    key: 'Micronesia, Federated States of Micronesia',
    text: '+691',
    flag: 'fm',
    value: '+691',
  },
  {
    key: 'Moldova',
    text: '+373',
    flag: 'md',
    value: '+373',
  },
  {
    key: 'Monaco',
    text: '+377',
    flag: 'mc',
    value: '+377',
  },
  {
    key: 'Mongolia',
    text: '+976',
    flag: 'mn',
    value: '+976',
  },
  {
    key: 'Montenegro',
    text: '+382',
    flag: 'me',
    value: '+382',
  },
  {
    key: 'Montserrat',
    text: '+1664',
    flag: 'ms',
    value: '+1664',
  },
  {
    key: 'Morocco',
    text: '+212',
    flag: 'ma',
    value: '+212',
  },
  {
    key: 'Mozambique',
    text: '+258',
    flag: 'mz',
    value: '+258',
  },
  {
    key: 'Myanmar',
    text: '+95',
    flag: 'mm',
    value: '+95',
  },
  {
    key: 'Namibia',
    text: '+264',
    flag: 'na',
    value: '+264',
  },
  {
    key: 'Nauru',
    text: '+674',
    flag: 'nr',
    value: '+674',
  },
  {
    key: 'Nepal',
    text: '+977',
    flag: 'np',
    value: '+977',
  },
  {
    key: 'Netherlands',
    text: '+31',
    flag: 'nl',
    value: '+31',
  },
  {
    key: 'Netherlands Antilles',
    text: '+599',
    flag: 'an',
    value: '+599',
  },
  {
    key: 'New Caledonia',
    text: '+687',
    flag: 'nc',
    value: '+687',
  },
  {
    key: 'New Zealand',
    text: '+64',
    flag: 'nz',
    value: '+64',
  },
  {
    key: 'Nicaragua',
    text: '+505',
    flag: 'ni',
    value: '+505',
  },
  {
    key: 'Niger',
    text: '+227',
    flag: 'ne',
    value: '+227',
  },
  {
    key: 'Nigeria',
    text: '+234',
    flag: 'ng',
    value: '+234',
  },
  {
    key: 'Niue',
    text: '+683',
    flag: 'nu',
    value: '+683',
  },
  {
    key: 'Norfolk Island',
    text: '+672',
    flag: 'nf',
    value: '+672',
  },
  {
    key: 'Northern Mariana Islands',
    text: '+1670',
    flag: 'mp',
    value: '+1670',
  },
  {
    key: 'Norway',
    text: '+47',
    flag: 'no',
    value: '+47',
  },
  {
    key: 'Oman',
    text: '+968',
    flag: 'om',
    value: '+968',
  },
  {
    key: 'Pakistan',
    text: '+92',
    flag: 'pk',
    value: '+92',
  },
  {
    key: 'Palau',
    text: '+680',
    flag: 'pw',
    value: '+680',
  },
  {
    key: 'Palestinian Territory, Occupied',
    text: '+970',
    flag: 'ps',
    value: '+970',
  },
  {
    key: 'Panama',
    text: '+507',
    flag: 'pa',
    value: '+507',
  },
  {
    key: 'Papua New Guinea',
    text: '+675',
    flag: 'pg',
    value: '+675',
  },
  {
    key: 'Paraguay',
    text: '+595',
    flag: 'py',
    value: '+595',
  },
  {
    key: 'Peru',
    text: '+51',
    flag: 'pe',
    value: '+51',
  },
  {
    key: 'Philippines',
    text: '+63',
    flag: 'ph',
    value: '+63',
  },
  {
    key: 'Pitcairn',
    text: '+64',
    flag: 'pn',
    value: '+64',
  },
  {
    key: 'Poland',
    text: '+48',
    flag: 'pl',
    value: '+48',
  },
  {
    key: 'Portugal',
    text: '+351',
    flag: 'pt',
    value: '+351',
  },
  {
    key: 'Puerto Rico',
    text: '+1939',
    flag: 'pr',
    value: '+1939',
  },
  {
    key: 'Qatar',
    text: '+974',
    flag: 'qa',
    value: '+974',
  },
  {
    key: 'Romania',
    text: '+40',
    flag: 'ro',
    value: '+40',
  },
  {
    key: 'Russia',
    text: '+7',
    flag: 'ru',
    value: '+7',
  },
  {
    key: 'Rwanda',
    text: '+250',
    flag: 'rw',
    value: '+250',
  },
  {
    key: 'Reunion',
    text: '+262',
    flag: 're',
    value: '+262',
  },
  {
    key: 'Saint Helena, Ascension and Tristan Da Cunha',
    text: '+290',
    flag: 'sh',
    value: '+290',
  },
  {
    key: 'Saint Kitts and Nevis',
    text: '+1869',
    flag: 'kn',
    value: '+1869',
  },
  {
    key: 'Saint Lucia',
    text: '+1758',
    flag: 'lc',
    value: '+1758',
  },
  {
    key: 'Saint Pierre and Miquelon',
    text: '+508',
    flag: 'pm',
    value: '+508',
  },
  {
    key: 'Saint Vincent and the Grenadines',
    text: '+1784',
    flag: 'vc',
    value: '+1784',
  },
  {
    key: 'Samoa',
    text: '+685',
    flag: 'ws',
    value: '+685',
  },
  {
    key: 'San Marino',
    text: '+378',
    flag: 'sm',
    value: '+378',
  },
  {
    key: 'Sao Tome and Principe',
    text: '+239',
    flag: 'st',
    value: '+239',
  },
  {
    key: 'Saudi Arabia',
    text: '+966',
    flag: 'sa',
    value: '+966',
  },
  {
    key: 'Senegal',
    text: '+221',
    flag: 'sn',
    value: '+221',
  },
  {
    key: 'Serbia',
    text: '+381',
    flag: 'rs',
    value: '+381',
  },
  {
    key: 'Seychelles',
    text: '+248',
    flag: 'sc',
    value: '+248',
  },
  {
    key: 'Sierra Leone',
    text: '+232',
    flag: 'sl',
    value: '+232',
  },
  {
    key: 'Singapore',
    text: '+65',
    flag: 'sg',
    value: '+65',
  },
  {
    key: 'Slovakia',
    text: '+421',
    flag: 'sk',
    value: '+421',
  },
  {
    key: 'Slovenia',
    text: '+386',
    flag: 'si',
    value: '+386',
  },
  {
    key: 'Solomon Islands',
    text: '+677',
    flag: 'sb',
    value: '+677',
  },
  {
    key: 'Somalia',
    text: '+252',
    flag: 'so',
    value: '+252',
  },
  {
    key: 'South Africa',
    text: '+27',
    flag: 'za',
    value: '+27',
  },
  {
    key: 'South Sudan',
    text: '+211',
    flag: 'sd',
    value: '+211',
  },
  {
    key: 'South Georgia and the South Sandwich Islands',
    text: '+500',
    flag: 'gs',
    value: '+500',
  },
  {
    key: 'Spain',
    text: '+34',
    flag: 'es',
    value: '+34',
  },
  {
    key: 'Sri Lanka',
    text: '+94',
    flag: 'lk',
    value: '+94',
  },
  {
    key: 'Sudan',
    text: '+249',
    flag: 'sd',
    value: '+249',
  },
  {
    key: 'Surikey',
    text: '+597',
    flag: 'sr',
    value: '+597',
  },
  {
    key: 'Svalbard and Jan Mayen',
    text: '+47',
    flag: 'sj',
    value: '+47',
  },
  {
    key: 'Swaziland',
    text: '+268',
    flag: 'sz',
    value: '+268',
  },
  {
    key: 'Sweden',
    text: '+46',
    flag: 'se',
    value: '+46',
  },
  {
    key: 'Switzerland',
    text: '+41',
    flag: 'ch',
    value: '+41',
  },
  {
    key: 'Syrian Arab Republic',
    text: '+963',
    flag: 'sy',
    value: '+963',
  },
  {
    key: 'Taiwan',
    text: '+886',
    flag: 'tw',
    value: '+886',
  },
  {
    key: 'Tajikistan',
    text: '+992',
    flag: 'tj',
    value: '+992',
  },
  {
    key: 'Tanzania, United Republic of Tanzania',
    text: '+255',
    flag: 'tz',
    value: '+255',
  },
  {
    key: 'Thailand',
    text: '+66',
    flag: 'th',
    value: '+66',
  },
  {
    key: 'Timor-Leste',
    text: '+670',
    flag: 'tl',
    value: '+670',
  },
  {
    key: 'Togo',
    text: '+228',
    flag: 'tg',
    value: '+228',
  },
  {
    key: 'Tokelau',
    text: '+690',
    flag: 'tk',
    value: '+690',
  },
  {
    key: 'Tonga',
    text: '+676',
    flag: 'to',
    value: '+676',
  },
  {
    key: 'Trinidad and Tobago',
    text: '+1868',
    flag: 'tt',
    value: '+1868',
  },
  {
    key: 'Tunisia',
    text: '+216',
    flag: 'tn',
    value: '+216',
  },
  {
    key: 'Turtext',
    text: '+90',
    flag: 'tr',
    value: '+90',
  },
  {
    key: 'Turkmenistan',
    text: '+993',
    flag: 'tm',
    value: '+993',
  },
  {
    key: 'Turks and Caicos Islands',
    text: '+1649',
    flag: 'tc',
    value: '+1649',
  },
  {
    key: 'Tuvalu',
    text: '+688',
    flag: 'tv',
    value: '+688',
  },
  {
    key: 'Uganda',
    text: '+256',
    flag: 'ug',
    value: '+256',
  },
  {
    key: 'Ukraine',
    text: '+380',
    flag: 'ua',
    value: '+380',
  },
  {
    key: 'United Arab Emirates',
    text: '+971',
    flag: 'ae',
    value: '+971',
  },
  {
    key: 'United Kingdom',
    text: '+44',
    flag: 'gb',
    value: '+44',
  },
  {
    key: 'Uruguay',
    text: '+598',
    flag: 'uy',
    value: '+598',
  },
  {
    key: 'Uzbekistan',
    text: '+998',
    flag: 'uz',
    value: '+998',
  },
  {
    key: 'Vanuatu',
    text: '+678',
    flag: 'vu',
    value: '+678',
  },
  {
    key: 'Venezuela, Bolivarian Republic of Venezuela',
    text: '+58',
    flag: 've',
    value: '+58',
  },
  {
    key: 'Vietnam',
    text: '+84',
    flag: 'vn',
    value: '+84',
  },
  {
    key: 'Virgin Islands, British',
    text: '+1284',
    flag: 'vg',
    value: '+1284',
  },
  {
    key: 'Virgin Islands, U.S.',
    text: '+1340',
    flag: 'vi',
    value: '+1340',
  },
  {
    key: 'Wallis and Futuna',
    text: '+681',
    flag: 'wf',
    value: '+681',
  },
  {
    key: 'Yemen',
    text: '+967',
    flag: 'ye',
    value: '+967',
  },
  {
    key: 'Zambia',
    text: '+260',
    flag: 'zm',
    value: '+260',
  },
  {
    key: 'Zimbabwe',
    text: '+263',
    flag: 'zw',
    value: '+263',
  },
];

export default countryCodesAndFlags;
